const broadband = {
  name: 'Broadband',
  pill: `From {bb}* Per Month`,
  icon: 'broadband/broadband',
  url: '/compare-tv-broadband-phone/'
};

const energy = {
  name: 'Energy',
  pill: `Save {nrg}* Per Year`,
  icon: 'energy/energy',
  url: '/compare-gas-electricity-prices/'
};

const carInsurance = {
  name: 'Car Insurance',
  pill: '10% Online Discount',
  icon: 'insurance/car',
  url: '/compare-car-insurance/'
};

export const HEALTH_INSURANCE = {
  name: 'Health Insurance',
  icon: 'insurance/health',
  url: '/compare-health-insurance/'
};

const homeInsurance = {
  name: 'Home Insurance',
  pill: '10% Online Discount',
  icon: 'insurance/home',
  url: '/compare-home-insurance/'
};

const lifeInsurance = {
  name: 'Life Insurance',
  pill: 'Premiums from €10 Per Month',
  icon: 'insurance/life',
  url: '/compare-life-insurance/'
};

const mortgageProtection = {
  name: 'Mortgage Protection',
  pill: 'Premiums from €10 Per Month',
  icon: 'insurance/mort-prot',
  url: '/compare-mortgage-protection-insurance/'
};

const mortgages = {
  name: 'Mortgages',
  pill: 'Free Mortgage Broker Service',
  icon: 'mortgage/mortgage',
  url: '/compare-mortgages/'
};

const savings = {
  name: 'Savings Accounts',
  pill: 'Better Returns',
  icon: 'banking/savings',
  url: '/compare-savings-accounts/'
};

const loans = {
  name: 'Personal Loans',
  pill: 'Compare Rates',
  icon: 'banking/personal-loans',
  url: '/compare-loans/'
};

export const PREPAID_CARDS = {
  name: 'Prepaid Credit Cards',
  pill: 'Find the best prepaid credit card',
  icon: 'banking/prepaid',
  key: 'PRE',
  url: '/compare-prepaid-credit-cards/'
};

export const CREDIT_CARDS = {
  name: 'Credit Cards',
  pill: 'Find the best credit card',
  icon: 'banking/credit',
  key: 'CC',
  url: '/compare-credit-cards/'
};

export const HOMEPAGE = {
  products: [
    mortgages,
    energy,
    broadband,
    savings,
    loans,
    carInsurance,
    homeInsurance,
    mortgageProtection,
    lifeInsurance,
    {
      name: 'Business Energy',
      pill: 'Save up to 45%',
      icon: 'energy/business',
      url: '/compare-gas-electricity-prices/business/'
    }
  ]
};

export const ENERGY = {
  products: [
    {
      name: 'Gas & Electricity',
      icon: 'energy/bolt',
      url: 'https://www.bonkers.ie/compare-gas-electricity-prices/dual-fuel/'
    },
    {
      name: 'Electricity only',
      icon: 'energy/lamp',
      url: 'https://www.bonkers.ie/compare-gas-electricity-prices/electricity/'
    },
    {
      name: 'Gas only',
      icon: 'energy/gas',
      url: 'https://www.bonkers.ie/compare-gas-electricity-prices/gas/'
    }
  ]
};

export const BANKING = {
  products: [
  mortgages,
  savings,
  {
    name: 'Current Accounts',
    icon: 'banking/current',
    url: '/compare-current-accounts/'
  },
  CREDIT_CARDS,
  PREPAID_CARDS,
  loans
]
};

export const INSURANCE = {
  products: [
  carInsurance,
  homeInsurance,
  lifeInsurance,
  {
    name: 'Income Protection',
    icon: 'insurance/income',
    url: '/compare-income-protection-insurance/'
  },
  mortgageProtection,
  {
    name: 'Serious Illness',
    icon: 'insurance/serious-ill',
    url: '/compare-serious-illness-cover/'
  },
  HEALTH_INSURANCE
]
};

export const MORTGAGES = {
  products: [
    {
      name: 'First-time buyer',
      icon: 'mortgage/key',
      key: 'FTB',
      path: '/compare-mortgages/first-time-buyer/stage/'
    },
    {
      name: 'Moving home',
      icon: 'mortgage/house',
      key: 'TRD',
      path: '/compare-mortgages/moving-home/stage'
    },
    {
      name: 'Switching mortgage',
      icon: 'mortgage/block',
      key: 'SM',
      path: '/compare-mortgages/switching-mortgage/stage'
    },
    {
      name: 'Lifetime Loan (Equity Release)',
      icon: 'mortgage/lifetimeHouse',
      key: 'LL',
      path: '/compare-mortgages/lifetime-loans/',
      pill: 'NEW!'
    }
  ]
};

export const SAVINGS = {
  products: [
    {
      name: 'Lump Sum Saver',
      icon: 'banking/loot',
      key: 'LUMP'
    },
    {
      name: 'Regular Monthly Saver',
      icon: 'banking/calendar',
      key: 'REG'
    }
  ]
};

export const CROSS_SELL = {
  heading: 'Why stop now? Compare and switch household bills',
  products: [
    {
      name: 'Energy',
      pill: `Save {nrg}* Per Year`,
      icon: 'energy/energy',
      url: '/compare-gas-electricity-prices/'
    },
    broadband,
    {
      name: 'Insurance',
      pill: 'Find the lowest rates',
      icon: 'insurance/health',
      url: '/compare-insurance/'
    },
    {
      name: 'Banking',
      pill: 'Lower your costs',
      icon: 'banking/savings',
      url: '/money/'
    }
  ]
};
